import {Component, ElementRef, EventEmitter, Injector, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '../../services/apis.service';
import { NotificationsComponent } from '../notifications/notifications.component';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2'
import {Base} from '../base/base';
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-edit-vehicle',
  templateUrl: './edit-vehicle.component.html',
  styleUrls: ['./edit-vehicle.component.css'
  ]
})
export class EditVehicleComponent extends Base {
  isReject: boolean = false;
  public vehicleForm: FormGroup;
  descriptionReject: any = '';
  loading: boolean = false;
  message_description: any = '';
  @ViewChild('inputFileSoat') inputFileSoat: ElementRef;
  @ViewChild('inputFileEnrollFront') inputFileEnrollFront: ElementRef;
  @ViewChild('inputFileEnrollBack') inputFileEnrollBack: ElementRef;
  @ViewChild('inputFileTecnoFront') inputFileTecnoFront: ElementRef;
  @ViewChild('inputFileTecnoBack') inputFileTecnoBack: ElementRef;
  @ViewChild('inputFileVehicle1') inputFileVehicle1: ElementRef;
  @ViewChild('inputFileVehicle2') inputFileVehicle2: ElementRef;
  @ViewChild('inputFileVehicle3') inputFileVehicle3: ElementRef;
  imageSoat = '';
  imageEnrollFront = '';
  imageEnrollBack = '';
  imageTecnoFront = '';
  imageTecnoBack = '';
  imageVehicle1 = '';
  imageVehicle2 = '';
  imageVehicle3 = '';
  public url_base = this.URL_BASE;
  @Input() public data;
  modelTecno: NgbDateStruct;
  modelSoat: NgbDateStruct;
  @Input() public action;

  constructor(injector: Injector,
              private form: FormBuilder,
              private router: Router,
              private NgxSpinner: NgxSpinnerService,
              private apis: ApisService,
              private notification: NotificationsComponent) {
      super(injector);
  }

  ngOnInit() {
    console.log('llego data (this.data, this.action) :: ', this.data, this.action);
    this.modelSoat = {
      "year": parseInt(this.data.date_soat.split(['-'])[0]),
      "month": parseInt(this.data.date_soat.split(['-'])[1]),
      "day": parseInt(this.data.date_soat.split(['-'])[2].split(' ')[0])
    }

    this.modelTecno= {
      "year": parseInt(this.data.date_tecno.split(['-'])[0]),
      "month": parseInt(this.data.date_tecno.split(['-'])[1]),
      "day": parseInt(this.data.date_tecno.split(['-'])[2].split(' ')[0])
    }

    this.vehicleForm = this.form.group({
      license_plate: [this.data['license_plate'], {validators: [Validators.required]}],
      date_soat: [this.data['date_soat'], {validators: [Validators.required]}],
      date_tecno: [this.data['date_tecno'], {validators: [Validators.required]}],
    });
  }

  onSubmit() {
    const form = this.vehicleForm.value;
    if (this.data && this.data.vehicle_id && form && form.date_soat && form.date_tecno && form.license_plate) {


      Swal.fire({
        title: 'Confirmar !!',
        text: "¿Estás seguro de que quieres actualizar la información?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3e7932',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, aceptar'
      }).then((result) => {
        if (result && result.value && result.value === true) {
          this.loading = true;
          form['vehicle_id'] = this.data.vehicle_id;
          this.apis.updateInfoVehicle(form).then(result => {
            if (result['status'] == 'success') {
              this.loading = false;
              this.notification.showNotification('bottom', 'left', 'success', 'Información guardada correctamente.');
              setTimeout(() => {
                location.reload();
              }, 1000);
            }
          });
        }
      })
    } else {
      this.notification.showNotification('bottom', 'left', 'error', 'Error en la información.');
    }
  }



  handleInputChange(image, name) {
    let file = image.target.files[0];
    let context = this;
    var reader: any = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      switch (name) {
        case 'soat':
          context.imageSoat = reader.result.split(',')[1];
          break;
        case 'enrollment_front':
          context.imageEnrollFront = reader.result.split(',')[1];
          break;
        case 'enrollment_back':
          context.imageEnrollBack = reader.result.split(',')[1];
          break;
        case 'technomechanics_front':
          context.imageTecnoFront = reader.result.split(',')[1];
          break;
        case 'technomechanics_back':
          context.imageTecnoBack = reader.result.split(',')[1];
          break;
        case 'vehicle_1':
          context.imageVehicle1 = reader.result.split(',')[1];
          break;
        case 'vehicle_2':
          context.imageVehicle2 = reader.result.split(',')[1];
          break;
        case 'vehicle_3':
          context.imageVehicle3 = reader.result.split(',')[1];
          break;
      }
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  saveImagen(name) {
    if (this.data && this.data.vehicle_id) {
      console.log('save ', name, this.imageSoat);
      let image = '';
      let imageOld = '';
      switch (name) {
        case 'soat':
          image = this.imageSoat;
          imageOld = this.data.soat;
          break;
        case 'enrollment_front':
          image = this.imageEnrollFront;
          imageOld = this.data.enrollment_front;
          break;
        case 'enrollment_back':
          image = this.imageEnrollBack;
          imageOld = this.data.enrollment_back;
          break;
        case 'technomechanics_front':
          image = this.imageTecnoFront;
          imageOld = this.data.technomechanics_front;
          break;
        case 'technomechanics_back':
          image = this.imageTecnoBack;
          imageOld = this.data.technomechanics_back;
          break;
        case 'vehicle_1':
          image = this.imageVehicle1;
          imageOld = this.data.vehicle_1;
          break;
        case 'vehicle_2':
          image = this.imageVehicle2;
          imageOld = this.data.vehicle_2;
          break;
        case 'vehicle_3':
          image = this.imageVehicle3;
          imageOld = this.data.vehicle_3;
          break;
      }
      let data = {
        vehicle_id: this.data.vehicle_id,
        name: name,
        image: image,
        imageOld: imageOld
      };

      this.apis.updateImageDocumentsVehicle(data).then(result => {
        if (result['status'] == 'success') {
          this.data[name] = result['data'][name];
        }
      });
    }
  }

  resetInputFile(event, name) {
    console.log('reset ', event);
    switch (name) {
      case 'soat':
        this.inputFileSoat.nativeElement.value = '';
        break;
      case 'enrollment_front':
        this.inputFileEnrollFront.nativeElement.value = '';
        break;
      case 'enrollment_back':
        this.inputFileEnrollBack.nativeElement.value = '';
        break;
      case 'technomechanics_front':
        this.inputFileTecnoFront.nativeElement.value = '';
        break;
      case 'technomechanics_back':
        this.inputFileTecnoBack.nativeElement.value = '';
        break;
      case 'vehicle_1':
        this.inputFileVehicle1.nativeElement.value = '';
        break;
      case 'vehicle_2':
        this.inputFileVehicle2.nativeElement.value = '';
        break;
      case 'vehicle_3':
        this.inputFileVehicle3.nativeElement.value = '';
        break;
    }
  }
}
